import React, { useEffect, useMemo, useState } from 'react';
import { sendBoxCommand } from '../utils/api';

const BOX_COMMAND_OPTIONS = [
  { id: 1, value: 'OPEN', label: 'Open' },
  { id: 2, value: 'CLOSE', label: 'Close' },
  { id: 3, value: 'LOCK', label: 'Lock' },
  { id: 4, value: 'UNLOCK', label: 'Unlock' },
  { id: 5, value: 'STATUS', label: 'Check Status' }
];

const getHotelBoxId = (box) =>
  box.DHTHTBX_id ||
  box.DHTHTBX_ID ||
  box.DHTHTBX_Id ||
  box.DHTHTBXid ||
  box.DHTHTB_id ||
  box.DHTHOTBOX_id ||
  box.DHTHOTBOXid ||
  box.hotelBoxId ||
  box.hotel_box_id ||
  box.DHTBOX_id;

const BoxController = ({ boxes = [] }) => {
  const boxOptions = useMemo(
    () =>
      boxes
        .map((box) => ({
          id: String(box.DHTBOX_id || '').trim(),
          hotelBoxId: getHotelBoxId(box),
          label: `Box ${box.DHTBOX_id}`
        }))
        .filter((box) => box.id),
    [boxes]
  );

  const [selectedBoxId, setSelectedBoxId] = useState(boxOptions[0]?.id || '');
  const [selectedCommand, setSelectedCommand] = useState(BOX_COMMAND_OPTIONS[0].value);
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    if (!boxOptions.length) {
      setSelectedBoxId('');
      return;
    }

    const hasSelectedBox = boxOptions.some((box) => box.id === selectedBoxId);

    if (!hasSelectedBox) {
      setSelectedBoxId(boxOptions[0].id);
    }
  }, [boxOptions, selectedBoxId]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedBoxId || !selectedCommand) {
      alert('Please choose a box and a command.');
      return;
    }

    setIsSending(true);

    try {
      const selectedBox = boxOptions.find((box) => box.id === selectedBoxId);
      const selectedCommandOption = BOX_COMMAND_OPTIONS.find((commandOption) => commandOption.value === selectedCommand);

      await sendBoxCommand({
        boxId: selectedBoxId,
        hotelBoxId: selectedBox?.hotelBoxId,
        command: selectedCommand,
        commandId: selectedCommandOption?.id
      });
      alert(`Command "${selectedCommand}" sent to box ${selectedBoxId}.`);
    } catch (error) {
      alert(`Error: ${error.message}`);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="card home-card control-card h-100">
      <div className="card-body p-3 d-flex flex-column">
        <h6 className="card-title text-center mb-3">Control Box</h6>
        <form onSubmit={handleSubmit} className="flex-grow-1 d-flex flex-column">
          <div className="mb-3">
            <label className="form-label small mb-1 opacity-75">Target Box</label>
            <select
              className="form-select home-input"
              value={selectedBoxId}
              onChange={(event) => setSelectedBoxId(event.target.value)}
              required
              disabled={!boxOptions.length || isSending}
            >
              {boxOptions.length > 0 ? (
                boxOptions.map((box) => (
                  <option key={box.id} value={box.id}>
                    {box.label}
                  </option>
                ))
              ) : (
                <option value="">No boxes available</option>
              )}
            </select>
          </div>
          <div className="mb-3">
            <label className="form-label small mb-1 opacity-75">Command</label>
            <select
              className="form-select home-input"
              value={selectedCommand}
              onChange={(event) => setSelectedCommand(event.target.value)}
              required
              disabled={isSending}
            >
              {BOX_COMMAND_OPTIONS.map((commandOption) => (
                <option key={commandOption.value} value={commandOption.value}>
                  {commandOption.label}
                </option>
              ))}
            </select>
          </div>
          <button type="submit" className="btn btn-home w-100 mt-5,5" disabled={isSending || !boxOptions.length}>
            {isSending ? 'Sending...' : 'Send Command'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BoxController;
